import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import IconTooltipButton from '../../../../../button/IconTooltipButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataGrid from '../../../../../table/DataGrid';

const FlagsList = ({ list = [], isLoading, permissions, onModal }) => {
    const columnsTable = [
    {
      show: true,
      key: 'primary',
      align: 'center',
      hide: false,
      width: 5,
      label: ''
    },
    {
      show: true,
      key: 'name',
      align: 'left',
      hide: false,
      width: 200,
      label: 'Name'
    },
    {
      show: permissions['preview'] || permissions['updated'] || permissions['deleted'],
      key: 'actions',
      align: 'center',
      hide: false,
      width: 50,
      label: 'actions'
    }
  ];

  return (
    <DataGrid
      id='flags-list'
      showSetting={false}
      rowsPerPage={list?.length || 10}
      rows={list.map((row) => {
        return {
          ...row,
          primary: <div className='flex items-center justify-center'>
            {row.icon ? (
              <div className='size-10 flex items-center justify-center rounded-full'>
                <FontAwesomeIcon icon={row.icon} size='xl' color={row.color} />
              </div>
            ) : (
              <div className='size-8 flex items-center justify-center bg-muted text-muted-foreground rounded-full' style={{ backgroundColor: row.color }} />
            )}
          </div>,
          actions: (
            <div>
              {permissions['preview'] && (
                <IconTooltipButton
                  title='Preview'
                  icon='expand-alt'
                  onClick={() => onModal('preview', row)}
                />
              )}
              {permissions['updated'] && (
                <IconTooltipButton
                  title='Edit'
                  icon={['fas', 'edit']}
                  onClick={() => onModal('edit', row)}
                />
              )}
              {permissions['deleted'] && (
                <IconTooltipButton
                  title='Delete'
                  icon={['fas', 'trash-alt']}
                  onClick={() => onModal('delete', row)}
                />
              )}
            </div>
          )

        };
      })}
      loading={isLoading}
      columns={columnsTable}
      labelNoRows="You don't have any term yet"
    />
  );

};

export default FlagsList;
